<template>
    <div>
      <a-row :gutter="24" type="flex">
        <a-col :span="24" class="mb-24">
          <a-card
            :bordered="false"
            class="header-solid h-full"
            :bodyStyle="{ padding: 0 }"
          >
            <template #title>
              <a-row type="flex" align="middle">
                <a-col :span="24" :md="12">
                  <h5 class="font-semibold m-0">جدول تیکت ها</h5>
                </a-col>
                <a-col
                  :span="24"
                  :md="12"
                  style="display: flex;  align-items: center; justify-content: flex-end; "
                >
                  <a-button
                    class="btn-outline-purple"
                    icon="search"
                    @click="isHidden = !isHidden"
                  >
                    جستجو
                  </a-button>
                  &nbsp;
                </a-col>
              </a-row>
            </template>
  
            <b-card style="margin:20px; !important ; border:none;" v-if="isHidden">
              <div class="row">
               <div class="col-md-4 my-1">
                                                                   <UserSearch @ids="getIds" />

                            </div>
                             <div class="col-md-4 my-1">
                                <label class="sr-only" for="inline-form-input-name"> وضعیت تیکت</label>
                                <select v-model="search.status" class="form-control">
                                    <option value="">انتخاب</option>
                                    <option value="waiting">  در انتظار پاسخ</option>
                                    <option value="closed">تیکت بسته</option>
                                    <option value="open"> تیکت باز </option>
                                </select>
                            </div>
               <div class="col-md-2 my-4">
                  <a-button
                    class="btn-outline-green w-100"
                    icon="search"
                    @click="getData"
                  >
                    جستجو
                  </a-button>
                  
                </div>
              </div>
            </b-card>
            <a-row
              style="justify-content: center; display: flex"
              v-if="$store.state.loading"
            >
              <template>
                <div>
                  <a-spin />
                </div>
              </template>
            </a-row>
            <div v-else>
              <section class="w-100 p-4 text-center">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th scope="col">شناسه</th>
                      <th scope="col">کاربر</th>
                      <th scope="col"> موضوع تیکت</th>
                      <th scope="col"> وضعیت تیکت</th>
                      <th scope="col">  تاریخ</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in data">
                      <th scope="row">#{{ row.id }}</th>
                      <td>
                        <b-avatar
                          size="1.5rem"
                          :src="$root.image_concat(row.user.image)"
                        ></b-avatar>
  
                        <b-badge variant="light" class="text-dark">
                        {{row.user ?  $root.full_name(row . user . firstname , row . user . lastname) : '' }}</b-badge>
                      </td>
                    
                      <td>
                        {{row.subject}}
                      </td>
                       <td>
                      
                        <b-badge pill v-if="row.status == 'closed'" variant="info" class="bg-success">
                            {{row.status}}
                        </b-badge>
                        <b-badge pill v-else-if="row.status == 'waiting'" variant="warning" class="bg-warning">
                            {{ row.status }}
                        </b-badge>
                        <b-badge pill v-else variant="danger" class="bg-danger">
                            {{ row.status }}
                        </b-badge>
                      </td>
                      <td>{{ new Date(row.created_at).toLocaleDateString('fa-IR') }}</td>
                      <td>
                        <a-button
                        v-show="$root.hasPermission('/tickets/detail/')"
                          class="btn-outline-primary"
                          shape="square"
                          :href="'/tickets/detail/'+row.id"
                        >جزییات</a-button>
                      
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <a-row class="pagination">
                <a-pagination
                  :total="total"
                  :item-render="$root.itemRender"
                  @change="getData(currentPage)"
                  v-model="currentPage"
                />
              </a-row>
            </div>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </template>
  
  <script>
      import UserSearch from "../../components/Blocks/UserSelectMultiple.vue"

  export default {
     components: {
            UserSearch
        },
    data() {
      return {
        data: [],
        currentPage: 1,
        total: 0,
        isHidden: false,
        search: {
          user_id: [],
          status: "",
        },
      };
    },
    methods: {
      getIds(value) {
                this.search.caller_id=value
            },
      async getData() {
        let _this = this;
        this.$store.state.loading = true;
        let url = `/tickets?page=${this.currentPage}&&user_id=${this.search.user_id}&&status=${this.search.status}`;
        await axios
          .get(url)
          .then(function (response) {
            _this.data = response.data.data;
            _this.$store.state.loading = false;
            _this.total = response.data.total;
            _this.currentPage = response.data.current_page;
          })
          .catch(function (err) {
            _this.$root.handleAxiosError(err);
          });
      },
     
    },
    mounted() {
      this.getData();
    },
  };
  </script>
  
  <style scope>
  .pagination {
    display: flex;
    justify-content: center;
    margin: 15px;
  }
  </style>
  